import styled from "styled-components";


export const InfoContainer = styled.div`
    color: antiquewhite;
    background: ${({ lightBg }) => (lightBg ? '#F5E8E1' : '#1B335A')};

    @media screen and (max-width: 768px){
        padding: 100px 0;
    }
`;

export const InfoWrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 720px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;

    @media screen and (max-width: 768px) {
        height: 840px;
        padding-left: 30px;
    }
`;

export const InfoRow = styled.div`
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    margin-top: 3em;
    grid-template-areas: ${({imgStart}) => 
    (imgStart ? `'col2 col1` : `'col1 col2'`)};

    @media screen and (max-width: 768px) {
        grid-template-areas: ${({imgStart}) => 
        (imgStart ? `'col1' 'col2` : `'col1 col1' 'col2 col2'`)};
    }
`;

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`;

export const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
`;

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;
`;

export const TopLine = styled.p`
    color: #2BBAE0;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`;

export const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 700;
    color: ${({lightText}) => (lightText ? 'antiquewhite' : '#442E1E')};
    
    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`;

export const Subtitle = styled.h2`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 20px;
    line-height: 24px;
    color: ${({darkText}) => (darkText ? '#442E1E' : 'antiquewhite')};
`;

export const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const ImgWrap = styled.div`
    max-width: 400px;
    height: 100%;

    @media screen and (max-width: 768px) {
        margin: auto;
    }
`;

export const Img = styled.img`
    width: 100%;
    margin: 0 0 10px 0;
    padding-right: 0;
`;

export const InfoList = styled.ul`
    list-style-type: circle;
    margin: 1rem;
`;

export const IList = styled.li`
    padding-top: 0.5rem;
    font-size: 20px;
    line-height: 24px;
    color: ${({darkText}) => (darkText ? '#442E1E' : 'antiquewhite')};

    @media screen and (max-width: 480px) {
        font-size: 16px;
    }
`;